import { useAuth } from "../auth";
import { Api } from "../machine-certificate-api-models";

// get token
const { cachedIdToken } = useAuth();

const machineCertificateHttpClient = new Api({
	baseApiParams: { secure: true },
	securityWorker: async () => {
		return {
			headers: { Authorization: `Bearer ${cachedIdToken.value}` },
		};
	},
});
export const initMachineCertificateClient = (defaultUrl: string) => {
	machineCertificateHttpClient.baseUrl = `${defaultUrl}`;
};

export const useMachineCertificateHttp = (): Api<unknown> =>
	machineCertificateHttpClient as Api<unknown>;
